module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Bake Me I’m Yours… Seasonal Push Pop Cakes")])]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('strong', [_vm._v("MORE THAN 10 PUSH POP CAKE DESIGNS FOR SEASONAL CELEBRATIONS")])]), _vm._v(" "), _c('h3', {
    staticClass: "CH-AU"
  }, [_c('strong', [_vm._v("KATIE DEACON")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.gif"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_c('strong', [_c('em', [_c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk/kitchen",
      "target": "_blank"
    }
  }, [_vm._v("www.stitchcraftcreate.co.uk/kitchen")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e9b09e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 57
// module chunks = 0